import { transformGenerality } from 'practice/utils/transform-request-step-register-office';
import { CompleteSubjectLink } from 'shell/models/person/complete-subject-link';
import { FamilyCoexistence } from 'shell/models/person/family';
import { Generality } from 'shell/models/person/generality';
import { Residence } from 'shell/models/person/residence';
import { SubjectAttributes } from 'shell/models/person/subject-attributes';
import { AccordionFamilyCoexistence } from 'shell/view-models/accordion-family-coexistence';
import { AccordionGeneralityForm } from 'shell/view-models/accordion-generality-form';
import { AllegatiVO, ControlData, Parent } from 'subscription/models/request-subscription-birth';
import {
  CivilStatusVM,
  CommonInterfaceSubscription,
  DocumentVM,
  EditDataControl,
  ForeignVM,
  SubscriptionAccordionGenerality,
} from 'subscription/view-models/common-interface-subscription';

export const transformerPaternita = (
  values?: CommonInterfaceSubscription['fatherhood']
): Parent | undefined => {
  const generalitaPadre = transformGenerality(values?.generality as AccordionGeneralityForm);

  const paternita: Parent | undefined = generalitaPadre
    ? {
        generalita: generalitaPadre || undefined,
        // mancano oggetti del type Parent
      }
    : undefined;

  return paternita;
};

export const transformMaternita = (
  values?: CommonInterfaceSubscription['motherhood']
): Parent | undefined => {
  const generalitaMadre = transformGenerality(values?.generality as AccordionGeneralityForm);

  const maternita: Parent | undefined = generalitaMadre
    ? {
        generalita: generalitaMadre || undefined,
        // mancano oggetti del type Parent
      }
    : undefined;

  return maternita;
};

export const transformFamiglia = (
  values: AccordionFamilyCoexistence,
  type?: string,
  isCohabitation?: boolean
): FamilyCoexistence | undefined => {
  if (
    !values?.codeIstat &&
    !values?.municipalityIdentifier &&
    !values?.identifierAnpr &&
    !values?.familyAire &&
    !values?.originDate &&
    !values?.reasonConstitution &&
    !values?.cohabitingFamily &&
    !values?.especiallyCoexistence
  ) {
    return undefined;
  }
  return {
    idFamigliaConvivenzaComune:
      values?.codeIstat || values?.municipalityIdentifier
        ? {
            idFamigliaConvivenzaComuneIstat: values?.codeIstat || undefined,
            idFamigliaConvivenza: values?.municipalityIdentifier || undefined,
          }
        : undefined,
    idFamigliaConvivenzaANPR: values?.identifierAnpr || undefined,
    famigliaAire: values?.familyAire || undefined,
    dataOrigineFamigliaConvivenza: values?.originDate
      ? values?.originDate?.toFormat('yyyy-MM-dd')
      : undefined,
    motivoCostituzione: values?.reasonConstitution || undefined,
    denominazioneConvivenza: values?.cohabitingFamily || undefined,
    specieConvivenza: values?.especiallyCoexistence || undefined,
    tipoMovimentazione: isCohabitation ? undefined : values?.handlingType || undefined,
    tipoScheda: type || undefined,
  };
};

export const transformLegameSoggetto = (
  values: AccordionFamilyCoexistence | undefined,
  isCohabitation?: boolean
): CompleteSubjectLink => {
  return {
    tipoLegame: !isCohabitation ? '3' : '4', // TODO, da verificare
    dataDecorrenza: values?.bondDate ? values?.bondDate?.toFormat('yyyy-MM-dd') : undefined,
    codiceLegame: !isCohabitation ? values?.relationship : values?.coexistenceBond,
    progressivoComponente: values?.progComponent || undefined,
  };
};

export const transformDatiControllo = (values?: EditDataControl): ControlData => {
  return {
    origineCognome: values?.assume || undefined,
    filiazione: values?.requested?.toString() || undefined,
    attribuzioneFamiglia: values?.subscribeTo || undefined,
    gestioneCF: values?.flag || '0',
  };
};

export const transformDatiControlloAire = (values?: EditDataControl): ControlData => {
  return {
    attribuzioneFamigliaAIRE: values?.subscribeTo || undefined,
    gestioneCF: values?.flag || undefined,
  };
};

export const transformGeneralita1001 = (
  generality: SubscriptionAccordionGenerality | undefined,
  civilStatus: CivilStatusVM | undefined,
  idSchedaSoggettoANPR?: string,
  isWithoutChoiceDate?: boolean
): {
  attributiSoggetto?: SubjectAttributes;
  generalita: Generality;
  statoCivile?: { statoCivile?: string };
} => {
  // Attributi soggetto non presente non li ho....
  const generalita = transformGenerality(
    {
      ...(generality || {}),
      anprIdentifier: generality?.anprIdentifier || idSchedaSoggettoANPR || undefined,
    } as AccordionGeneralityForm,
    isWithoutChoiceDate
  );

  return {
    generalita: {
      ...generalita,
    },
    attributiSoggetto: {
      senzaFissaDimora: 'N',
      soggettoCertificabile: '2',
    },
    statoCivile:
      !civilStatus?.available && civilStatus?.status
        ? {
            statoCivile: civilStatus?.status?.toString() || undefined,
          }
        : undefined,
  };
};

export const transformResidenzaEstera = (values?: ForeignVM): Residence | undefined => {
  if (
    !values?.cap &&
    !values?.municipality &&
    !values?.foreignState &&
    !values?.address &&
    !values?.civicNumber &&
    !values?.consulateCode?.id
  ) {
    return;
  }
  return {
    localitaEstera: {
      indirizzoEstero: {
        cap: values?.cap || undefined,
        localita: {
          descrizioneLocalita: values?.municipality?.description || undefined,
          descrizioneStato: values?.foreignState?.value || undefined,
          codiceStato: values?.foreignState?.id || undefined,
          provinciaContea: values?.municipality?.province || undefined,
        },
        toponimo: {
          denominazione: values?.address || undefined,
          numeroCivico: values?.civicNumber || undefined,
        },
      },
      consolato: {
        codiceConsolato: values?.consulateCode?.id?.toString() || undefined,
        descrizioneConsolato: values?.consulateCode?.value || undefined,
      },
    },
  };
};

export const transformAllegati = (values?: DocumentVM): Array<AllegatiVO> | undefined => {
  if ((values?.files || []).length === 0) {
    return undefined;
  }

  return values?.files?.map((item) => ({
    contenutoAllegato: item.raw?.split(',')[1] || undefined,
    nomeFile: item.name || undefined,
    tipoOrigine: 'C', // fixed
  }));
};
